import styled, { css } from "styled-components";

const AddressesContainer = styled.div`
    margin-bottom: 30px;
    margin-top: 33px;
    @media (min-width: 768px) {
        padding-left: 50px;
    }

    .lt-sec,
    .rt-sec {
        > .inner {
            max-width: 350px;
        }
    }

    .form-lt,
    .form-rt,
    .form-ct {
        margin-bottom: 20px;
    }
    .form-lt,
    .form-rt {
        width: 50%;
    }
    .form-ct {
        width: 100%;
    }
    .form-lt {
        padding-right: 10px;
    }
    .form-rt {
        padding-left: 10px;
    }

    .default-form-input {
        box-shadow: none !important;
        border-color: #333;
        &:focus {
            border-color: #000;
        }
    }

    .form-item.has-error {
        > input,
        > select,
        > textarea {
            border-color: #dc3545;
        }
    }

    .default-btn {
        width: 100%;
        border: 2px solid #333;
        font-size: 13px;
        padding: 9px 12px;
        background-color: #333;
        color: #fff;
        height: 40px;
        &:hover {
            background-color: #000;
        }
    }

    ${(props) =>
        props.theme &&
        css`
            @media (min-width: ${props.theme.breakpoints.md_min}px) {
                .form-content {
                    max-width: 60%;
                }
            }
        `}

    .address-lists {
        .frac {
            margin: 0 30px 30px 0;
            > .frac-inner {
                border: 1px solid #333;
                width: 250px;
                min-height: 150px;
                padding: 15px 15px;
            }
        }
        .add-address {
            > .frac-inner {
                transition: 0.3s;
                &:hover {
                    background-color: #efefef;
                }
            }
        }
    }
`;

export { AddressesContainer };
